import React from "react";
import PostContainer from "../components/post/PostContainer";
import Sidebar from "../components/sidebar/Sidebar";

function Home() {
  return (
    <section className="wrapper">
      <Sidebar />
      <PostContainer />
    </section>
  );
}

export default Home;
